<div class="modal-header">
  <h5 class="modal-title">Import Proxies</h5>
  <button class="close" (click)="close()"><span>&times;</span></button>
</div>
<div class="modal-body">
  <!-- Result panel -->
  <div *ngIf="showResult" class="mb-3">
    <div class="alert alert-success" *ngIf="importedCount > 0">
      <i class="fas fa-check-circle"></i> Imported {{ importedCount }} proxies.
    </div>
    <div class="alert alert-warning" *ngIf="warnings.length > 0">
      <strong>{{ warnings.length }} proxies already exist:</strong>
      <ul class="mb-0 mt-1">
        <li *ngFor="let w of warnings">
          <strong>{{ w.host }}</strong> — {{ w.message }}
          <ul *ngIf="w.currentUsages && w.currentUsages.length > 0">
            <li *ngFor="let u of w.currentUsages">{{ u }}</li>
          </ul>
        </li>
      </ul>
    </div>
  </div>

  <!-- Validation errors -->
  <div *ngIf="validationErrors.length > 0" class="alert alert-danger mb-3">
    <strong>Lỗi dữ liệu:</strong>
    <ul class="mb-0 mt-1">
      <li *ngFor="let err of validationErrors">{{ err }}</li>
    </ul>
  </div>

  <!-- Input form -->
  <div class="form-group">
    <label>Danh sách proxy
      <small class="text-muted" *ngIf="fileType !== 'csv' && fileType !== 'xlsx'">(Host:Port:User:Pass)</small>
      <small class="text-muted" *ngIf="fileType === 'csv' || fileType === 'xlsx'">(CSV/XLSX template)</small>
    </label>
    <textarea class="form-control" rows="8" [(ngModel)]="lines"
              placeholder="1.2.3.4:1080:user:pass&#10;5.6.7.8:8080:user2:pass2"></textarea>
  </div>

  <div class="form-group">
    <label>Hoặc upload file (.txt, .csv, .xlsx)</label>
    <input type="file" class="form-control-file" accept=".txt,.csv,.xlsx" (change)="onFileChange($event)" />
    <small class="text-muted d-block mt-1">
      <a href="https://drive.google.com/file/d/1-zyS-hw9nyEdemq3pmcJP4zbMtPCPwhO/view" target="_blank">Template</a>
      nếu dùng CSV/XLSX với nhiều thông tin hơn, nếu dùng TXT vẫn theo định dạng Host:Port:Username:Password
    </small>
  </div>

  <!-- Protocol selector — only for TXT/manual input (CSV/XLSX has port columns) -->
  <div class="form-group" *ngIf="fileType !== 'csv' && fileType !== 'xlsx'">
    <label>Loại proxy</label>
    <select class="form-control" [(ngModel)]="protocol">
      <option value="SOCKS5">SOCKS5</option>
      <option value="HTTP">HTTP</option>
    </select>
  </div>

  <div class="row">
    <div class="col-md-6 form-group">
      <label>Start Date</label>
      <input class="form-control" type="date" [(ngModel)]="startDate" />
    </div>
    <div class="col-md-6 form-group">
      <label>End Date</label>
      <input class="form-control" type="date" [(ngModel)]="endDate" />
    </div>
  </div>

  <div class="form-group">
    <label>Nguồn proxy</label>
    <ng-select [items]="sources" bindValue="id" bindLabel="name"
               [closeOnSelect]="true" placeholder="Chọn nguồn..."
               [(ngModel)]="sourceId"></ng-select>
  </div>

  <div class="form-group">
    <label>Chi phí / tháng (USD)</label>
    <app-all-to-usd [(des)]="costUsd"></app-all-to-usd>
    <small class="text-muted d-block">Lưu vào cột chi phí hàng tháng; tổng chi phí tích lũy bắt đầu từ 0.</small>
  </div>

  <div class="form-group">
    <label>Ghi chú</label>
    <input class="form-control" [(ngModel)]="note" />
  </div>

</div>
<div class="modal-footer">
  <button class="btn btn-light" (click)="close()">Đóng</button>
  <button class="btn btn-primary" (click)="doImport()">
    <i class="fas fa-file-import"></i> Import
  </button>
</div>
